/** Beräkningar längs en rutt: hur långt och hur länge det är kvar. */

const EARTH_RADIUS_M = 6371000;
const toRad = (deg) => (deg * Math.PI) / 180;

/** Avstånd i meter mellan två [lat, lng]-punkter. */
export function distanceBetween([lat1, lng1], [lat2, lng2]) {
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a = Math.sin(dLat / 2) ** 2
    + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * EARTH_RADIUS_M * Math.asin(Math.min(1, Math.sqrt(a)));
}

/**
 * Närmaste punkt på rutten. Jämför mot ruttens hörn, vilket räcker: OSRM
 * ger tät geometri, så felet blir mindre än GPS:ens egen osäkerhet.
 */
export function nearestIndex(route, position) {
  let best = 0;
  let bestDistance = Infinity;

  for (let i = 0; i < route.length; i++) {
    const d = distanceBetween(route[i], position);
    if (d < bestDistance) {
      bestDistance = d;
      best = i;
    }
  }
  return { index: best, distance: bestDistance };
}

/** Total längd i meter för hela rutten. */
export function totalDistance(route) {
  let sum = 0;
  for (let i = 1; i < route.length; i++) sum += distanceBetween(route[i - 1], route[i]);
  return sum;
}

/** Meter kvar från nuvarande position till målet. */
export function remainingDistance(route, position) {
  if (!route || route.length < 2 || !position) return 0;

  const { index } = nearestIndex(route, position);
  let sum = distanceBetween(position, route[index]);
  for (let i = index + 1; i < route.length; i++) {
    sum += distanceBetween(route[i - 1], route[i]);
  }
  return sum;
}

/**
 * Minuter kvar. Korsningspåslaget fördelas i proportion till hur mycket av
 * sträckan som återstår — de flesta korsningarna ligger kvar framför en i
 * början av resan och nästan inga i slutet.
 */
export function remainingMinutes({ metersLeft, totalMeters, speedKmh, delaySeconds = 0 }) {
  if (!speedKmh || metersLeft <= 0) return 0;

  const share = totalMeters > 0 ? Math.min(1, metersLeft / totalMeters) : 1;
  const driveMinutes = (metersLeft / 1000 / speedKmh) * 60;
  return Math.max(1, Math.round(driveMinutes + (delaySeconds * share) / 60));
}

/** Klockslag för framkomst, som "19:42". */
export function arrivalTime(minutesLeft) {
  const arrival = new Date(Date.now() + minutesLeft * 60000);
  return new Intl.DateTimeFormat('sv-SE', { hour: '2-digit', minute: '2-digit' }).format(arrival);
}
